const digest = '9873ecbf99e0a7e50cb41da280d90443f5bcd9dd5d136a8910c25bfc224b0c4b';
const css = `html[data-dls-mode=dark] [data-dls-surface=fg-dramatic] {
  background-color: black;
}
html[data-dls-mode=light] [data-dls-surface=fg-dramatic] {
  background-color: white;
}

._shortSilentVideoModal_1nllr_8 {
  height: 100dvh;
}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'shortSilentVideoModal': '_shortSilentVideoModal_1nllr_8' };
export const shortSilentVideoModal = '_shortSilentVideoModal_1nllr_8';
export { css, digest };